import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { detailBuildEmployer } from "../../actions/employerAction";
import Signout from "../../components/Signout";
import AdminMenu from "../../components/AdminMenu";
import RightDash from "../../components/RightDash";
import Message from "../../components/Message";
import Api from "../../Api";
import { message } from "antd";

const AdminJobDetails = ({ match, history, resizeMenu, setResizeMenu }) => {
  const [status, setStatusValue] = useState("");
  const [deleteLoading, setDeleteLoading] = useState(false);
  const id = match.params.id;

  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);

  const { userInfo } = userLogin;

  const detailBuild = useSelector((state) => state.detailBuild);

  const { loading, job, error } = detailBuild;

  useEffect(() => {
    dispatch(detailBuildEmployer(id));
  }, [detailBuildEmployer]);

  useEffect(() => {
    if (job !== undefined && Object.keys(job).length) {
      setStatusValue(job.status);
    }
  }, [job]);

  const deleteBuild = async (e) => {
    try {
      setDeleteLoading(true);

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const res = await axios.delete(
        `${Api}/api/employers/build/${id}`,
        config
      );

      console.log(res.data);
      setDeleteLoading(false);

      message.success(res.data.message);
      history.push("/admin/jobs");
    } catch (error) {
      error.response && error.response.data.error
        ? message.error(error.response.data.error)
        : error.message
        ? message.error(error.message)
        : message.error(error.data);

      setDeleteLoading(false);
    }
  };

  const handleChange = async (e) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const res = await axios.put(
        `${Api}/api/admin/buildStatus/${id}`,
        { status },
        config
      );

      console.log(res.data);

      message.success(res.data.message);
      window.location.reload();
    } catch (error) {
      error.response && error.response.data.error
        ? message.error(error.response.data.error)
        : error.message
        ? message.error(error.message)
        : message.error(error.data);
    }
  };

  console.log(status);

  return (
    <div className="dashboard">
      <AdminMenu resizeMenu={resizeMenu} setResizeMenu={setResizeMenu} />
      <RightDash resizeMenu={resizeMenu} setResizeMenu={setResizeMenu}>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100 h-100">
            <div className="spinner-blue"></div>
          </div>
        ) : error ? (
          <Message variant="danger">{error}</Message>
        ) : (
          <div className="right-wrapper">
            <div className="bio text-right">
              <button>
                <span>Hello Admin, Welcome!</span>
                <span className="px-50 py-25 rounded-circle ml-25 font-weight-bold font-sm">
                  A
                </span>
              </button>
            </div>
            <div className="main p-3">
              <div className="">
                <div>ID: {job._id}</div>
                <h4 className="font-medium mb-50 d-flex align-items-center">
                  {job.title}
                  <Link
                    to={`/admin/job/edit/${job._id}`}
                    className="ml-1 font-normal apply-btn px-1">
                    Edit
                  </Link>
                  <button
                    onClick={deleteBuild}
                    className="ml-1 vertical-middle">
                    <i class="far fa-trash-alt"></i>
                  </button>
                  {deleteLoading ? <div className="spinner-blue"></div> : ""}
                </h4>
                <h5 className="font-normal">by {job.user && job.user.name}</h5>
                <p>
                  <span className="font-weight-bolder">Email:</span>{" "}
                  {job.user && job.user.email}
                </p>
                <div>
                  <p>{job.details}</p>
                  <p>
                    {job.file && job.file.length ? (
                      <div>
                        {" "}
                        <span className="font-weight-bolder">File:</span>{" "}
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={job.file}>
                          document
                        </a>
                      </div>
                    ) : (
                      ""
                    )}
                  </p>
                  <p>
                    <span className="font-weight-bolder">Skills required:</span>{" "}
                    {job && job.skill && job.skill.join(", ")}
                  </p>
                  <p>
                    <span className="font-weight-bolder">Budget(USD):</span>{" "}
                    {job.budget}
                  </p>
                  <p>
                    <span className="font-weight-bolder">Status:</span>{" "}
                    {job.status}
                  </p>
                  <div>
                    <select
                      className="select mb-2 mr-1"
                      value={status}
                      onChange={(e) => setStatusValue(e.target.value)}>
                      <option value="negotiation">Negotiation</option>
                      <option value="progress">In Progress</option>
                      <option value="completed">Completed</option>
                    </select>
                    <button
                      onClick={handleChange}
                      className="apply-btn rounded px-1">
                      change
                    </button>
                  </div>
                </div>
              </div>
              <div className="mt-2 dashtable">
                <h4 className="font-medium mb-1">
                  Dev Applied ({job.devapplied && job.devapplied.length})
                </h4>
                <div className="">
                  <table>
                    <thead>
                      <tr className="text-uppercase tablehead">
                        <th>date</th>
                        <th>name</th>
                        <th>email</th>
                        <th>cv </th>
                        <th>github</th>
                        <th>level</th>
                      </tr>
                    </thead>
                    {
                      <tbody>
                        {job.devapplied && job.devapplied.length === 0 && (
                          <div>No job application yet</div>
                        )}
                        {job.devapplied &&
                          job.devapplied.map((applied) => (
                            <tr key={applied._id}>
                              <td data-label="date">
                                {applied.createdAt.slice(0, 10)}
                              </td>
                              <td data-label="name">{applied.user.name}</td>
                              <td data-label="email">
                                <a href={`mailto:${applied.user.email}`}>
                                  {applied.user.email}
                                </a>
                              </td>
                              <td data-label="cv">
                                <a
                                  rel="noreferrer"
                                  target="_blank"
                                  href={applied.cv}>
                                  cv link
                                </a>
                              </td>
                              <td data-label="github">{applied.github}</td>
                              <td data-label="level">{applied.skillslevel}</td>
                            </tr>
                          ))}
                      </tbody>
                    }
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </RightDash>
    </div>
  );
};

export default AdminJobDetails;
